module.exports = __webpack_public_path__ + "img/Weapon_174.f548ffcd.png";